import { FlexFileError } from './FlexFileError';

import {ReportDataService} from '../../report-data.service';

export class InvalidReportCalRangeError extends FlexFileError {

  protected reportService: ReportDataService;

  constructor(reportService: ReportDataService, additionalData) {
    super(reportService, 'Invalid date ranges in Reporting Calendar - Start Date must be on or before End Date', 'INVALID_DATE_RANGE', 0, true, additionalData);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/errors/InvalidReportCalRangeError.ts